/**
 * [(ngModel)] friendly h1
 * when you need to use [(ngModel)] on an h1 element
 * example usage:
 * <app-form-h1 [(ngModel)]="client.name"></app-form-h1>
 * <app-form-h1 [(ngModel)]="client.name" contenteditable></app-form-h1>
 *
 * http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
 *
 * UPDATE: [ngModel] (property binding) works, (ngModel) (event binding) does not
 */

import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';


const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FormH1Component),
    multi: true
};


@Component({
	selector: 'app-form-h1',
	templateUrl: './form-h1.component.html',
	styleUrls: ['./form-h1.component.css'],
	// providers: [
	// 	{
	// 		provide: NG_VALUE_ACCESSOR, useExisting: FormH1Component, multi: true
	// 	},
	// ],
	providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
	host: {'(ngModelChange)': 'doSomething($event)'}
})


export class FormH1Component implements ControlValueAccessor {

	//The internal data model
	private innerValue: any = '';

	@Input() placeholder: string = '...';

	//Placeholders for the callbacks which are later providesd
	//by the Control Value Accessor
	private onTouchedCallback: () => void = noop;
	private onChangeCallback: (_: any) => void = noop;

	//get accessor
	get value(): any {
		return this.innerValue;
	};

	//set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.onChangeCallback(v);
		}
	}

	//Set touched on blur
	onBlur() {
		console.log('blurrrr');
		this.onTouchedCallback();
	}

	//From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	//From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	//From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

}



// WEBPACK FOOTER //
// ./src/app/form-h1/form-h1.component.ts